import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AUTH_BASE_URL } from '@skynet/config-provider';
import { isAuthTokenStore } from './helpers';
import { customHeaders } from './headers';

/**
 * Create the custom base query with configured headers.
 * This base query can be reused in other API slices that need auth headers.
 */
export const authApiBaseQuery = fetchBaseQuery({
  baseUrl: AUTH_BASE_URL,
  credentials: 'include',
  prepareHeaders: async (headers, { getState }) => {
    const state = getState();
    if (isAuthTokenStore(state)) {
      return customHeaders(headers, state);
    }
    return headers;
  },
});
